import { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api";
import type { User } from "../types";

export function LoginPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    api<{ user: User | null }>("/api/auth/me")
      .then(result => { if (result.user) navigate("/portal", { replace: true }); })
      .catch(() => {});
  }, [navigate]);
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); setLoading(true); setError("");
    const data = new FormData(event.currentTarget);
    try {
      await api("/api/auth/login", { method: "POST", body: JSON.stringify({ email: data.get("email"), password: data.get("password") }) });
      window.dispatchEvent(new Event("portal-auth-changed"));
      navigate("/portal");
    } catch (reason) { setError(reason instanceof Error ? reason.message : "Erro ao entrar"); }
    finally { setLoading(false); }
  }
  return <AuthShell title="Bem-vindo de volta" subtitle="Acesse suas empresas, pedidos e etapas de produção."><form className="auth-form" onSubmit={submit}><label>E-mail<input name="email" type="email" required autoComplete="email" /></label><label>Senha<input name="password" type="password" required autoComplete="current-password" /></label>{error && <div className="form-error">{error}</div>}<button className="button primary full" disabled={loading}>{loading ? "Entrando..." : "Entrar"}</button><p className="auth-switch">Ainda não possui acesso? <Link to="/cadastro">Criar cadastro</Link></p></form></AuthShell>;
}

export function AuthShell({ title, subtitle, children }: { title: string; subtitle: string; children: React.ReactNode }) {
  return <section className="auth-page"><div className="auth-card"><span className="eyebrow">Portal Holyman</span><h1>{title}</h1><p>{subtitle}</p>{children}</div><div className="auth-side"><div><span>Seu pedido, do início ao fim.</span><h2>Uma visão clara de cada etapa.</h2><p>Faça pedidos para diferentes CNPJs e acompanhe aprovação, produção e entrega.</p></div></div></section>;
}
